import Button from "@/common/components/Button";
import { useFormContext, useWatch } from "react-hook-form";
import { establishmentChoiceEntryOptions } from "../../../../constants/directiveEntryFormSteps/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant";
import { EstablishmentChoiceEntryManualEntrySchema } from "../../../../schemas/entries/establishmentChoiceEntry.schema";
import { useCreateForwardingsFormStore } from "../../../../stores/createForwardingsFormStore";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "../../../../types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";
import CreateForwardingDirectiveEntryFormStepHeader from "../../../CreateForwardingDirectiveEntryFormStepHeader";
import EstablishmentChoiceList from "../EstablishmentChoiceList";

const EstablishmentChoiceEntryManualEntryPending = () => {
  const {
    setSelectedEstablishments,
    increaseStep,
  } = useCreateForwardingsFormStore();

  const {
    control,
    setValue,
  } = useFormContext<EstablishmentChoiceEntryManualEntrySchema>();

  const {
    establishment_choice_entry_attributes: watchEstablishmentChoiceEntryAttributes,
  } = useWatch({
    control,
  });

  const watchEstablishmentId = watchEstablishmentChoiceEntryAttributes?.establishment_id;

  const manualEntryOption = establishmentChoiceEntryOptions[MaintenanceForwardingEstablishmentChoiceEntryKlass.ManualEntry];

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        goBackAction={() => {
          setValue('establishment_choice_entry_type', undefined!);
          setValue('establishment_choice_entry_attributes', undefined!);
        }}
        title={manualEntryOption.title}
        description={manualEntryOption.description}
      />

      <EstablishmentChoiceList
        selectedEstablishmentsIds={watchEstablishmentId ? [watchEstablishmentId] : []}
        onSelectEstablishment={(establishment) => {
          if (establishment.establishment_id === watchEstablishmentId) {
            setValue('establishment_choice_entry_attributes.establishment_id', undefined!);
            setSelectedEstablishments([]);

            return;
          }

          setValue('establishment_choice_entry_attributes.establishment_id', establishment.establishment_id);
          setSelectedEstablishments([establishment]);
        }}
      />

      <div className="flex items-center justify-between">
        <p className="text-sm">
          {watchEstablishmentId
            ? '1 Estabelecimento selecionado'
            : 'Nenhum estabelecimento selecionado'}
        </p>

        <div className="flex items-center gap-2">
          <Button
            variant="error"
            onClick={() => {
              setValue('establishment_choice_entry_type', undefined!);
              setValue('establishment_choice_entry_attributes', undefined!);
            }}
          >
            Cancelar
          </Button>

          <Button
            disabled={!watchEstablishmentId}
            onClick={increaseStep}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EstablishmentChoiceEntryManualEntryPending;
